import { RouteObject } from "react-router-dom";
import ProfilePage from "../../Pages/Profile/Profile";

export const PROFILE = "/profile";

const Profile: RouteObject[] = [{ path: PROFILE, element: <ProfilePage /> }];

export default Profile;
